module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "feedback-knowledge-js": "static-1.4805",
      "hs-test-utils": "static-1.7358",
      "I18n": "static-7.1455",
      "jasmine-runner": "static-1.5785",
      "quartz": "static-1.6184",
      "hubspot-url-utils": "static-1.3576",
      "outpost": "static-1.3684",
      "PatternValidationJS": "static-1.437",
      "react": "static-7.151",
      "moment": "static-3.26",
      "foundations-components": "static-1.6886",
      "framer-motion": "static-1.53",
      "hs-test-utils-bend-plugin": "static-1.2469",
      "msw": "static-1.39",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.135",
      "enviro": "static-4.342",
      "i18n-data": "static-1.208",
      "metrics-js": "static-1.9122",
      "moment-timezone": "static-5.68",
      "react-utils": "static-2.4750",
      "jasmine": "static-4.3677",
      "PortalIdParser": "static-2.318",
      "quartz-core-utils": "static-1.3051",
      "StyleGuideUI": "static-3.476",
      "quartz-core": "static-1.5403",
      "csstype": "static-1.50",
      "bend-plugin-foundations-components": "static-1.3155",
      "floating-ui": "static-1.41",
      "foundations-assets": "static-1.4224",
      "foundations-theming": "static-1.3712",
      "foundations-theming-specialty": "static-1.1428",
      "hs-story-utils": "static-1.8735",
      "react-aria": "static-1.44",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.82",
      "styled-components": "static-2.64",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.334",
      "ui-images": "static-2.970",
      "bender-build-tools": "static-1.2538",
      "hoist-non-react-statics": "static-3.9",
      "dispatcher": "static-1.122",
      "general-store": "static-6.20",
      "HeadJS": "static-2.625",
      "history": "static-4.47",
      "hs-promise-rejection-tracking": "static-1.4892",
      "hub-http": "static-1.5499",
      "hub-http-janus": "static-1.702",
      "hub-http-shared-msw-handlers": "static-1.8481",
      "hubspotter-http": "static-1.4011",
      "hubspotter-http-shared-msw-handlers": "static-1.8479",
      "icons": "static-2.596",
      "mobile-manifest-mixins": "static-1.397",
      "platform-navigation-bootstrap": "static-1.11883",
      "quick-fetch": "static-1.3395",
      "raven": "static-3.5366",
      "raven-hubspot": "static-1.5673",
      "react-rhumb": "static-1.15977",
      "react-router-dom": "static-5.26",
      "UIComponents": "static-3.7830",
      "webpack-env": "static-1.54",
      "bend-plugin-foundations-theming": "static-1.2195",
      "foundations-theming-base": "static-1.2697",
      "react-input-autosize": "static-2.17",
      "classnames": "static-2.10",
      "ts-schema": "static-1.3539",
      "sassPrefix": "static-1.142",
      "platform-infra-nav-components": "static-1.7121",
      "cssUtils": "static-1.605",
      "head-dlb": "static-1.4360",
      "HubStyle": "static-2.11191",
      "HubStyleTokens": "static-2.10883",
      "hs-lodash": "static-4.45"
    },
    "depPathPrefixes": {
      "feedback-knowledge-js": "/feedback-knowledge-js/static-1.4805",
      "hs-test-utils": "/hs-test-utils/static-1.7358",
      "I18n": "/I18n/static-7.1455",
      "jasmine-runner": "/jasmine-runner/static-1.5785",
      "quartz": "/quartz/static-1.6184",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3576",
      "outpost": "/outpost/static-1.3684",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react": "/react/static-7.151",
      "moment": "/moment/static-3.26",
      "foundations-components": "/foundations-components/static-1.6886",
      "framer-motion": "/framer-motion/static-1.53",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2469",
      "msw": "/msw/static-1.39",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.135",
      "enviro": "/enviro/static-4.342",
      "i18n-data": "/i18n-data/static-1.208",
      "metrics-js": "/metrics-js/static-1.9122",
      "moment-timezone": "/moment-timezone/static-5.68",
      "react-utils": "/react-utils/static-2.4750",
      "jasmine": "/jasmine/static-4.3677",
      "PortalIdParser": "/PortalIdParser/static-2.318",
      "quartz-core-utils": "/quartz-core-utils/static-1.3051",
      "StyleGuideUI": "/StyleGuideUI/static-3.476",
      "quartz-core": "/quartz-core/static-1.5403",
      "csstype": "/csstype/static-1.50",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3155",
      "floating-ui": "/floating-ui/static-1.41",
      "foundations-assets": "/foundations-assets/static-1.4224",
      "foundations-theming": "/foundations-theming/static-1.3712",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1428",
      "hs-story-utils": "/hs-story-utils/static-1.8735",
      "react-aria": "/react-aria/static-1.44",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.82",
      "styled-components": "/styled-components/static-2.64",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.334",
      "ui-images": "/ui-images/static-2.970",
      "bender-build-tools": "/bender-build-tools/static-1.2538",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "dispatcher": "/dispatcher/static-1.122",
      "general-store": "/general-store/static-6.20",
      "HeadJS": "/HeadJS/static-2.625",
      "history": "/history/static-4.47",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4892",
      "hub-http": "/hub-http/static-1.5499",
      "hub-http-janus": "/hub-http-janus/static-1.702",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8481",
      "hubspotter-http": "/hubspotter-http/static-1.4011",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8479",
      "icons": "/icons/static-2.596",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.397",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11883",
      "quick-fetch": "/quick-fetch/static-1.3395",
      "raven": "/raven/static-3.5366",
      "raven-hubspot": "/raven-hubspot/static-1.5673",
      "react-rhumb": "/react-rhumb/static-1.15977",
      "react-router-dom": "/react-router-dom/static-5.26",
      "UIComponents": "/UIComponents/static-3.7830",
      "webpack-env": "/webpack-env/static-1.54",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2195",
      "foundations-theming-base": "/foundations-theming-base/static-1.2697",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "classnames": "/classnames/static-2.10",
      "ts-schema": "/ts-schema/static-1.3539",
      "sassPrefix": "/sassPrefix/static-1.142",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7121",
      "cssUtils": "/cssUtils/static-1.605",
      "head-dlb": "/head-dlb/static-1.4360",
      "HubStyle": "/HubStyle/static-2.11191",
      "HubStyleTokens": "/HubStyleTokens/static-2.10883",
      "hs-lodash": "/hs-lodash/static-4.45"
    },
    "project": "feedback-knowledge-js",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};